import SuperToolView from "@features/super-tool/view";

const SuperTool = () => {
  return <SuperToolView />;
};

export default SuperTool;
